import { Badge } from '../ui/Badge';
import type { OmniboxInvoiceFigures, OmniboxRowKind } from './omnibox.items';

const ICON_PATHS: Record<OmniboxRowKind, string> = {
  client:
    'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
  matter:
    'M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z',
  invoice:
    'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  destination: 'M13 7l5 5m0 0l-5 5m5-5H6',
};

/** Decorative row icon for a result kind: person, folder, document or arrow (a destination). Colour comes from the row's tile. */
export function OmniboxKindIcon({ kind }: { kind: OmniboxRowKind }) {
  return (
    <svg
      className="h-4 w-4 shrink-0"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={ICON_PATHS[kind]} />
    </svg>
  );
}

/** An invoice row's right edge: the total over the status badge. */
export function OmniboxInvoiceTrailing({ amountLabel, statusLabel, statusVariant }: OmniboxInvoiceFigures) {
  return (
    <>
      <span className="text-sm font-medium tabular-nums text-secondary">{amountLabel}</span>
      <Badge variant={statusVariant}>{statusLabel}</Badge>
    </>
  );
}
